import { mapActions } from "vuex"
import { trackEvent } from "bits/analytics"
import { $ } from "bits/jquery"

export default {
  data() {
    return {
      dblClickToPostSubscribed: false
    }
  },
  methods: {
    ...mapActions('post', ['startNewPost']),
    enableDoubleClickToPost(wallContainerEl, wishListEl) {
      const wallContainerElement = wallContainerEl || document.getElementById("wall-container")
      const wishListElement = wishListEl || document.getElementById("wish-list")
      const $wallContainer = $(wallContainerElement)
      if (this.dblClickToPostSubscribed) return false
      $wallContainer.on("doubletap.doubleclicktopost dblclick.doubleclicktopost", (e) => {
        if (e.target == wishListElement || e.target == wallContainerElement || $(e.target).is("padlet-sections")) {
          e.preventDefault()
          let ev = e
          if (e.pageX) {
            //do nothing
          } else if (e.originalEvent.pageX) {
            ev = e.originalEvent
          } else if (e.originalEvent.touches && e.originalEvent.touches.length > 0) {
            ev = e.originalEvent.touches.item(0)
          }

          const position = {}
          position.left = ev.pageX - wishListElement.getBoundingClientRect().left
          position.top = ev.pageY - wishListElement.getBoundingClientRect().top
          trackEvent("Posts", "add", "Double Click")
          this.startNewPost({attributes: {...position}})
        }
      })
      this.dblClickToPostSubscribed = true
    },

    disableDoubleClickToPost(wallContainerEl) {
      const wallContainerElement = wallContainerEl || document.getElementById("wall-container")
      const $wallContainer = $(wallContainerElement)
      $wallContainer.off(".doubleclicktopost")
      this.dblClickToPostSubscribed = false
    }
  }
}